import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { pickRandomIndex } from '../../randomSelection';
import { COIN_FLIP_SOURCE_HANDLES } from '../coinFlipHandles';
import { CoinFlipNodeView } from '../views/CoinFlipNode';

export const coinFlipDefinition: NodeDefinition<'coinFlip'> = {
  label: 'Coin Flip',
  showInPalette: true,
  paletteColor: 'bg-slate-100 border-slate-500 text-slate-700',
  miniMapColor: '#64748b',
  defaultData: { label: 'Coin Flip' },
  view: CoinFlipNodeView,
  run: (_node, ctx, log) => {
    const isHeads = pickRandomIndex(2, ctx.random ?? Math.random) === 0;
    const branchLabel = isHeads ? '表' : '裏';
    log(`[Coin Flip] ${branchLabel}`);
    return {
      nextHandle: isHeads
        ? COIN_FLIP_SOURCE_HANDLES.heads
        : COIN_FLIP_SOURCE_HANDLES.tails,
      branchLabel,
    };
  },
  help: {
    title: [t('Coin Flip（コイントス）')],
    description: [
      t('コインを'),
      r('投', 'な'),
      t('げるように、「'),
      r('表', 'おもて'),
      t('」か「'),
      r('裏', 'うら'),
      t('」かがランダムに'),
      r('決', 'き'),
      t('まります。'),
      r('決', 'き'),
      t('まったほうの'),
      r('道', 'みち'),
      t('へ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
